// @ts-check

/** @typedef {import('./schema').components['schemas']} Schemas */
/** @typedef {Schemas['ErrorResponse']} ErrorResponse */
/** @typedef {Schemas['DetailErrorResponse']} DetailErrorResponse */
/** @typedef {Schemas['AddConferenceParticipantValidationError'] | Schemas['AddressBookEntryValidationError'] | Schemas['PhoneCallCreateValidationError'] | Schemas['PhoneCallUpdateValidationError']} TelehealthValidationError */
/** @typedef {ErrorResponse | DetailErrorResponse | TelehealthValidationError} TelehealthErrorBody */

/**
 * @typedef {object} ParsedTelehealthError
 * @property {string} message Error, detail or non-field message; empty when only field errors were returned.
 * @property {Record<string, string[]>} fieldErrors Per-field validation messages from a 400.
 * @property {string} summary First available message, for single-line displays.
 */

/**
 * Reads the declared error shapes returned by the telehealth endpoints.
 * @param {any} error Rejected axios error.
 * @param {string} fallback Shown when the response carries no message.
 * @returns {ParsedTelehealthError}
 */
export function parseTelehealthError(error, fallback) {
  /** @type {TelehealthErrorBody | undefined} */
  const body = error?.response?.data
  /** @type {Record<string, string[]>} */
  const fieldErrors = {}
  let message = ''

  if (body && typeof body === 'object') {
    if ('error' in body) {
      message = body.error
    } else if ('detail' in body) {
      message = body.detail
    } else {
      for (const [field, messages] of Object.entries(body)) {
        const list = (Array.isArray(messages) ? messages : [messages]).map(String)
        if (field === 'non_field_errors') message = list.join(' ')
        else fieldErrors[field] = list
      }
    }
  }

  const firstFieldError = Object.values(fieldErrors)[0]?.[0]
  return {
    message,
    fieldErrors,
    summary: message || firstFieldError || fallback,
  }
}
